import React from 'react';
import {useLocation } from 'react-router-dom';
import { Table } from "antd";
import Download from "./download";
import './displayResult.scss';

export default function DisplayResult(props) {
    let location = useLocation();
    const {dataSource, columns,...rest}=location.state || {};
    return (<Table
        dataSource={dataSource}
        columns={columns}
        footer={Download}
        bordered
        tableLayout='fixed'
        className="alysis-table"
        {...rest}
    />)
}